import React, { useState, useEffect } from "react";
import { Button, Modal, Layout, Icon } from "antd";
import _ from "i18n";
import { connect } from "react-redux";
import { Row, Col } from 'antd';
import { getNotPaidInvoices, getDoublePayment } from "../../../actions/thunks.js";
import { setFilterInvoicesByDay } from "../../../actions/actions.js";
import Piechart from "./PieChart";
import { formatAmount } from "utils";
import InvoiceDetail from "./InvoiceDetail";
import UnpaidInvoicesDetails from "./UnpaidInvoicesDetails";
import RecapByDate from "./RecapByDate";
import DoublePayment from "./DoublePayment";
import FeedMangoModal from "../FeedMangoWallet/FeedMangoModal";

const { Header, Footer, Sider, Content } = Layout;


const NotPaidInvoices = ({ facturationInfos,
  statisticsFilter,
  eventStatsFilter,
  notPaidInvoices,
  auth,
  getNotPaidInvoices,
  setFilterInvoicesByDay,
  getDoublePayment
}) => {

  const [operation_type, setOperationType] = useState(null);
  const [visible, setVisible] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isMangoModalVisible, setIsMangoModalVisible] = useState(false);
  const [orderIdForMangoRefund, setOrderIdForMangoRefund] = useState(null);
  const [amountToRefund, setAmountToRefund] = useState(0);


  const loadNotPaidInvoices = () => {
    getNotPaidInvoices(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, eventStatsFilter.year && eventStatsFilter.year.length > 0 ? eventStatsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []);

  };

  useEffect(() => {
    if (statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      loadNotPaidInvoices();
    }
  }, []);

  useEffect(() => {
    loadNotPaidInvoices();
  }, [statisticsFilter, eventStatsFilter.year]);


  const showModal = (operation_type) => {
    setVisible(true);
    setOperationType(operation_type);
  };


  const handleCancel = e => {
    setVisible(false);
    setOperationType(null);

    setFilterInvoicesByDay(null)
    setShowSpinner(false);
  };

  const changeState = (value) => {

    setShowSpinner(value);
  }

  const handleMangoModalVisibility = (value) => {
    setIsMangoModalVisible(value);
  };

  const openFeedMangoModal = (orderId, amountToRefund) => {
    setIsMangoModalVisible(true);
    setOrderIdForMangoRefund(orderId);
    setAmountToRefund(amountToRefund);
    handleCancel();
  };

  let totalOrder = 0;
  let totalInvoice = 0;
  let amountInvoice = 0;

  if (facturationInfos && facturationInfos.items && facturationInfos.items['order']) {
    totalOrder = (facturationInfos.items['order']['NOT_PAID'] ? parseInt(facturationInfos.items['order']['NOT_PAID'].count) : 0) + (facturationInfos.items['order']['PAID'] ? parseInt(facturationInfos.items['order']['PAID'].count) : 0) + (facturationInfos.items['order']['OVER_PAID'] ? parseInt(facturationInfos.items['order']['OVER_PAID'].count) : 0) + (facturationInfos.items['order']['UNDER_PAID'] ? parseInt(facturationInfos.items['order']['UNDER_PAID'].count) : 0)
  }


  if (notPaidInvoices && notPaidInvoices.items && notPaidInvoices.items[0] && notPaidInvoices.items[0]['including_vat_amount']) {
    totalInvoice = notPaidInvoices.items[0]['count_document'];
    amountInvoice = notPaidInvoices.items[0]['including_vat_amount'];
  }

  return (
    <div>
      <div className="fact-bloc">

        <div className="title">
          {_('mapCoda')}
        </div>

        <div>

          <Row gutter={16}>
            <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
              <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                <div className="flex items-center justify-center img-reconciliation">
                  <img src={"/img/icons/Ogone-Big.svg"} />
                </div>

                <div className="text-reconciliation pt-3">
                  {_('payment-ogone')}
                </div>

                <div className='pt-3 btn-reconciliation mt-20'>

                  <Button type='default' data-operation="OGONE" onClick={() => showModal("OGONE")}>
                    <span className="pr-2">
                      <img src={"/img/icons/SHOW.svg"} />
                    </span> {_('OGONE')}

                  </Button>

                  {visible && operation_type === 'OGONE' && <Modal
                    // title={this.state.operation_type}
                    visible={true}
                    onCancel={handleCancel}
                    footer={null}
                    width={'97%'}
                    style={{ top: 18 }}
                  >

                    <div className="bg-blue-lightest h-16 modal-header-title">
                      {_(operation_type)}
                    </div>

                    <div className="flex flex-row mt-8">

                      <div className="relative">
                        <div className="min-h-full">

                          <RecapByDate operationType={operation_type} changeState={changeState} />

                        </div>

                        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                          <Icon type="sync" spin style={{ fontSize: '50px' }} />

                        </div> : null
                        }
                      </div>
                      <div className="min-h-full w-full pl-8">
                        <InvoiceDetail operationType={operation_type} />
                      </div>
                    </div>
                  </Modal>}

                </div>
              </div>
            </Col>


            <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
              <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                <div className="flex items-center justify-center img-reconciliation">
                  <img src={"/img/icons/Payconiq-small.svg"} />
                </div>

                <div className="text-reconciliation pt-3">
                  {_('payment-pay-coniq')}
                </div>

                <div className='pt-3 btn-reconciliation mt-20'>

                  <Button type='default' data-operation="PAY_CONIQ" onClick={() => showModal("PAY_CONIQ")}>
                    <span className="pr-2">
                      <img src={"/img/icons/SHOW.svg"} />
                    </span> {_('Pay Coniq')}

                  </Button>

                  {visible && operation_type === 'PAY_CONIQ' && <Modal
                    // title={this.state.operation_type}
                    visible={true}
                    onCancel={handleCancel}
                    footer={null}
                    width={'97%'}
                    style={{ top: 18 }}
                  >

                    <div className="bg-blue-lightest h-16 modal-header-title">
                      {_(operation_type)}
                    </div>

                    <div className="flex flex-row mt-8">

                      <div className="relative">
                        <div className="min-h-full">

                          <RecapByDate operationType={operation_type} changeState={changeState} />

                        </div>

                        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                          <Icon type="sync" spin style={{ fontSize: '50px' }} />

                        </div> : null
                        }
                      </div>
                      <div className="min-h-full w-full pl-8">
                        <InvoiceDetail operationType={operation_type} />
                      </div>
                    </div>
                  </Modal>}

                </div>
              </div>
            </Col>

            <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
              <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                <div className="flex items-center justify-center img-reconciliation">
                  <img src={"/img/icons/mangopay-small.svg"} />
                </div>

                <div className="text-reconciliation pt-3">
                  {_('payment-mango-pay')}
                </div>

                <div className='pt-3 btn-reconciliation mt-20'>

                  <Button type='default' data-operation="MANGO_PAY" onClick={() => showModal("MANGO_PAY")}>
                    <span className="pr-2">
                      <img src={"/img/icons/SHOW.svg"} />
                    </span> {_('Mango pay')}

                  </Button>

                  {visible && operation_type === 'MANGO_PAY' && <Modal
                    // title={operation_type}
                    visible={true}
                    onCancel={handleCancel}
                    footer={null}
                    width={'97%'}
                    style={{ top: 18 }}
                  >

                    <div className="bg-blue-lightest h-16 modal-header-title">
                      {_(operation_type)}
                    </div>

                    <div className="flex flex-row mt-8">

                      <div className="relative">
                        <div className="min-h-full">

                          <RecapByDate operationType={operation_type} changeState={changeState} />

                        </div>

                        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                          <Icon type="sync" spin style={{ fontSize: '50px' }} />

                        </div> : null
                        }
                      </div>
                      <div className="min-h-full w-full pl-8">
                        <InvoiceDetail operationType={operation_type} />
                      </div>
                    </div>
                  </Modal>}

                </div>
              </div>
            </Col>


            <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
              <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                <div className="items-center justify-center img-reconciliation">
                  <img src={"/img/icons/BANK-TRANSFER.svg"} />
                </div>
                <div className="text-reconciliation pt-4 ">
                  {_('payment-virement')}
                </div>

                <div className='pt-3 btn-reconciliation mt-20'>
                  <Button type='default' data-operation="BANK-TRANSFER" onClick={() => showModal("BANK_TRANSFER")}>
                    <span className="pr-2">
                      <img src={"/img/icons/SHOW.svg"} />
                    </span> {_('BANK_TRANSFER')}

                  </Button>

                  {visible && operation_type === 'BANK_TRANSFER' && <Modal
                    visible={visible && operation_type === 'BANK_TRANSFER'}
                    onCancel={handleCancel}
                    footer={null}
                    width={'97%'}
                    style={{ top: 18 }}
                  >

                    <div className="bg-blue-lightest h-16 modal-header-title">
                      {_(operation_type)}
                    </div>

                    <div className="flex flex-row mt-8">

                      <div className="relative">

                        <div className="min-h-full">
                          <RecapByDate operationType={operation_type} changeState={changeState} />
                        </div>

                        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

                          <Icon type="sync" spin style={{ fontSize: '50px' }} />

                        </div> : null
                        }


                      </div>
                      <div className="min-h-full w-full pl-8">
                        <InvoiceDetail operationType={operation_type} />
                      </div>
                    </div>
                  </Modal>}
                </div>

              </div>
            </Col>

            <Col className="gutter-row" span={4} xs={20} sm={12} md={12} xl={4}>
              <div className="gutter-box payment-bloc-background flex flex-col items-center justify-center">
                <div className="items-center justify-center img-reconciliation">
                  <img src={"/img/icons/wallet.svg"} />
                </div>
                <div className="text-reconciliation pt-4">
                  {_('Consulter les commandes qui sont doublement payées')}
                </div>

                <div className='pt-3 btn-reconciliation mt-20'>
                  <Button type='default' data-operation="DOUBLE-PAYMENT" onClick={() => showModal("DOUBLE-PAYMENT")}>
                    <span className="pr-2">
                      <img src={"/img/icons/SHOW.svg"} />
                    </span> {_('Visualiser')}

                  </Button>

                  {visible && operation_type === 'DOUBLE-PAYMENT' && <Modal
                    visible={visible && operation_type === 'DOUBLE-PAYMENT'}
                    onCancel={handleCancel}
                    footer={null}
                    width={'97%'}
                    style={{ top: 18 }}
                  >
                    <div className="min-h-full">
                      <DoublePayment operationType={"DOUBLE-PAYMENT"} openFeedMangoModal={openFeedMangoModal} />
                    </div>

                  </Modal>}
                </div>

              </div>
            </Col>

            <Col className="gutter-row" span={4}>
              <div className="gutter-box payment-bloc-background ">

                <div className="sub-title-facturation">
                  {_('invoices-not-paid')}
                </div>
                <div className="line" />

                <div className="pl-24 md:pl-4 pt-4">
                  <Piechart total={totalOrder} count={totalInvoice} label={'invoice'} pieColor={'rgb(109, 127, 146)'} style={{ opacity: 0.1 }} color={'#FE3745'} />

                  <div className="flex items-center justify-center flex-col mr-3 mb-4">
                    <div className="text-center div-total">
                      TOTAL
                    </div>
                    <div className="text-center div-amount self-start">
                      {formatAmount(amountInvoice)}
                    </div>

                    {/*<div className="div-not-paid-invoice self-start">*/}
                    {/*  {totalInvoice +' '+ _('facture-a-payer')}*/}
                    {/*</div>*/}

                    <div className='pt-3 btn-reconciliation' style={{ marginTop: '0.1rem' }}>
                      <Button type='default' data-operation="UNPAID_INVOICES" onClick={() => showModal("UNPAID_INVOICES")}>
                        <span className="pr-2">
                          <img src={"/img/icons/SHOW.svg"} />
                        </span> {_('Visualiser')} </Button>


                      {visible && operation_type === 'UNPAID_INVOICES' && <Modal
                        visible={visible && operation_type === 'UNPAID_INVOICES'}
                        onCancel={handleCancel}
                        footer={null}
                        width={'97%'}
                        style={{ top: 26 }}
                      >

                        <div className="min-h-full">
                          <UnpaidInvoicesDetails operationType={"UNPAID_INVOICES"} />
                        </div>
                      </Modal>}

                    </div>

                  </div>

                </div>
              </div>
            </Col>


          </Row>

        </div>
      </div>
      <FeedMangoModal isModalVisible={isMangoModalVisible}
        handleModalVisibility={handleMangoModalVisibility}
        orderId={orderIdForMangoRefund}
        isCreditNote={0}
        creditNoteId={null}
        isRefund={1}
        redirectionURL={window.location.href}
        amountToRefund={amountToRefund}
      />
    </div>

  );
}

const mapStateToProps = state => ({
  facturationInfos: state.facturationInfos,
  statisticsFilter: state.filters.statisticsFilter,
  eventStatsFilter: state.filters.eventStatsFilter,
  notPaidInvoices: state.notPaidInvoices,
  auth: state.auth,

});

const mapDispatchToProps = {
  getNotPaidInvoices,
  setFilterInvoicesByDay,
  getDoublePayment
};

export default connect(mapStateToProps, mapDispatchToProps)(NotPaidInvoices);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/NotPaidInvoices.js